<div class="edit-container">
    <div class="d-flex justify-content-between align-items-center mt-1">
        <h1 class="m-0 p-0">Actualizează Document Oficial</h1>
        <button type="button" class="action-btn d-flex p-0" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <!-- <div class="row">
            <mat-form-field appearance="fill">
                <mat-label>ID Template</mat-label>
                <input type="text" matInput formControlName="template_id" />
            </mat-form-field>
        </div> -->
        <!-- this we need to hide please.. no needed -->
        <!-- <div class="row">
            <mat-form-field appearance="fill">
                <mat-label>Valabil</mat-label>
                <input matInput [matDatepicker]="pickerValabil" formControlName="valability" readonly
                    (focus)="pickerValabil.open()" />
                <mat-hint>ZZ/LL/AAAA</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="pickerValabil"></mat-datepicker-toggle>
                <mat-datepicker #pickerValabil></mat-datepicker>
            </mat-form-field>
        </div> -->
        <!-- <div class="row">
            <angular-editor formControlName="content" [config]="editorConfig"></angular-editor>
        </div> -->

        <!-- doc_type == 2 sticks -->
        <ng-container *ngIf="data.doc_type == 2">
            <br />
            <div>
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onDestinatieChange($event)" value="toPrimarie">
                    <mat-button-toggle value="toPrimarie">Exemplar Semnatari</mat-button-toggle>
                    <mat-button-toggle value="toCetatean">Exemplar Cetățean</mat-button-toggle>
                    <mat-button-toggle value="toate">Toate</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
            <br />
        </ng-container>

        <div class="row">
            <div class="col" *ngIf="destination == 'toPrimarie' || destination == 'toate'">
                <br />
                <div class="col">
                    <h2 class="fw-bold">Exemplar Semnatari</h2>
                    <br />
                    <angular-editor class="fit-screen" formControlName="content"
                        [config]="editorConfig"></angular-editor>
                </div>
            </div>
            <div class="col" *ngIf="destination == 'toCetatean' || destination == 'toate'">
                <br />
                <div class="col">
                    <h2 class="fw-bold">Exemplar Cetățean</h2>
                    <br />
                    <angular-editor class="fit-screen" formControlName="content_citizen"
                        [config]="editorConfig"></angular-editor>
                </div>
            </div>
        </div>
        <br />

        <div class="row">
            <div class="col">
                <div class="d-flex justify-content-end">
                    <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                        {{ helper.dialogConfig.buttonLabels.close }}
                    </button>
                    <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                        {{ helper.dialogConfig.buttonLabels.save }}
                    </button>
                </div>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>